import { htmlEscape } from "client/Misc/htmlUtils";

export function convertPlainTextBodyToHtml(email: string): string {
	return htmlEscape(email)
		.replace(/(\r\n|\r|\n)/g, "<br>");
}